import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import DeleteModal from "../../../components/Modal/DeleteModal";
import CustomFieldChoicesModal from "../customFieldChoicesModal";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./constants";
import CustomFieldChoicesCard from "./customFieldChoicesCard";
import {useCustomFieldChoicesTableActions} from "./useTableActions";
import {useCustomFieldChoicesTableData} from "./useTableData";

const CustomFieldChoicesTable = () => {
  const {
    deleteModalStatus,
    deleteCustomFieldChoice,
    editModalStatus,
    handleActionSelection,
    selectedCustomFieldChoice,
    setDeleteModalStatus,
    setEditModalStatus,
  } = useCustomFieldChoicesTableActions();
  const {paginationConfig, customFieldChoicesList, customFieldChoicesTotalCount} =
    useCustomFieldChoicesTableData();

  return (
    <Fragment>
      {editModalStatus && (
        <CustomFieldChoicesModal
          data={selectedCustomFieldChoice}
          onCancel={() => setEditModalStatus(false)}
          open={editModalStatus}
        />
      )}
      {deleteModalStatus && (
        <DeleteModal
          header={"Delete Custom Field Choice"}
          modalBody={"Are you sure you want to delete this custom field choice?"}
          onClose={() => setDeleteModalStatus(false)}
          onDelete={deleteCustomFieldChoice}
          open={deleteModalStatus}
        />
      )}
      <div className="table-container">
        <ListView
          actionsList={ACTIONS_LIST}
          cardContent={CustomFieldChoicesCard}
          listItems={customFieldChoicesList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={customFieldChoicesTotalCount}
          withActions
          withPagination={paginationConfig}
        />{" "}
      </div>
    </Fragment>
  );
};

export default CustomFieldChoicesTable;
